import { render, staticRenderFns } from "./CollapsePanel.vue?vue&type=template&id=65f84e24&"
import script from "./CollapsePanel.vue?vue&type=script&lang=ts&"
export * from "./CollapsePanel.vue?vue&type=script&lang=ts&"
import style0 from "./CollapsePanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports